const extensionsActionTypes = {
    REGISTER_TOOLBAR_COMPONENT: "REGISTER_TOOLBAR_COMPONENT",
    REGISTER_MULTIPLE_PAGES_COMPONENT: "REGISTER_MULTIPLE_PAGES_COMPONENT",
    REGISTER_PAGE_DETAILS_FOOTER_COMPONENT: "REGISTER_PAGE_DETAILS_FOOTER_COMPONENT",
    REGISTER_PAGE_SETTINGS_COMPONENT: "REGISTER_PAGE_SETTINGS_COMPONENT",
    REGISTER_SETTINGS_BUTTON_COMPONENT: "REGISTER_SETTINGS_BUTTON_COMPONENT",
    REGISTER_PAGE_TYPE_SELECTOR_COMPONENT: "REGISTER_PAGE_TYPE_SELECTOR_COMPONENT",
    REGISTER_INCONTEXTMENU_COMPONENT: "REGISTER_INCONTEXTMENU_COMPONENT",
    REGISTER_GET_WORKFLOW_LIST: "REGISTER_GET_WORKFLOW_LIST"
};

export default extensionsActionTypes;